import { useState, useEffect } from "react";

function loadGoogleAnalytics() {
  if (window._gaLoaded) return;
  window._gaLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "cookies_accepted" });
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookies_accepted");
    if (!consent) {
      setVisible(true);
    } else if (consent === "true") {
      loadGoogleAnalytics();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookies_accepted", "true");
    loadGoogleAnalytics();
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem("cookies_accepted", "false");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 px-4 py-4 md:px-8 md:py-5 flex flex-col md:flex-row items-center justify-between gap-4 border-t shadow-lg"
      style={{ backgroundColor: "var(--bg-card)", borderColor: "var(--border)" }}
    >
      <p className="text-sm text-center md:text-left" style={{ color: "var(--text-muted)" }}>
        🍪 Ce site utilise des cookies pour améliorer votre expérience et mesurer l'audience.{" "}
        <a href="/politique-cookies" style={{ color: "#2a7a6f", textDecoration: "underline" }}>
          En savoir plus
        </a>
      </p>

      <div className="flex items-center gap-3 shrink-0">
        <button
          onClick={handleAccept}
          className="px-5 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
        >
          Accepter
        </button>
        <button
          onClick={handleRefuse}
          className="px-5 py-2 text-sm font-medium rounded-lg border hover:opacity-70 transition"
          style={{ color: "var(--text)", borderColor: "var(--border)" }}
        >
          Refuser
        </button>
      </div>
    </div>
  );
}